import { RestrictedAccountObjectFacade } from "../restricted-account-object/restricted-account-object.facade";
import { Transition } from "./transition.model";
import { TransitionApiFacade } from "./transition.api-facade";
import { TransitionStoreFacade } from "./transition.store-facade";

export class TransitionFacade extends RestrictedAccountObjectFacade<Transition, TransitionApiFacade, TransitionStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/transition/transition.facade.ts